import { Box, Typography } from "@mui/material";
import OrderTable from "Components/Order/orderTable";
// import ExportButton from "Components/shared/ExportButton";
import { useRTL } from "hooks/isRTL";

const Orders = () => {
  const { t } = useRTL();
  return (
    <Box
      sx={{
        padding: "3.2rem 4.5rem",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h1">{t("ordersList")}</Typography>
      </Box>
      <OrderTable />
    </Box>
  );
};

export default Orders;
